import { render, staticRenderFns } from "./SubscriptionPeriodSelect.vue?vue&type=template&id=0845350c&scoped=true"
import script from "./SubscriptionPeriodSelect.vue?vue&type=script&lang=ts"
export * from "./SubscriptionPeriodSelect.vue?vue&type=script&lang=ts"
import style0 from "./SubscriptionPeriodSelect.vue?vue&type=style&index=0&id=0845350c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0845350c",
  null
  
)

export default component.exports